<template>
    <b-modal
        :ref="modalRef"
        title-tag="h2"
        :title="'Change Status'"
        lazy
        no-close-on-backdrop
        no-close-on-esc
    >
        <p>
            This invoice has been written off. Changing the status will reverse
            the write-off. Do you wish to continue?
        </p>

        <template v-slot:modal-footer>
            <modal-footer
                :is-loading="isLoading"
                ok-title="Yes"
                @ok-action="save"
                @cancel-action="close"
            />
        </template>
    </b-modal>
</template>
<script type="text/javascript">
export default {
    components: {
        modalFooter: () => import("@/components/elements/modal-footer")
    },
    props: {
        modalRef: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            isLoading: false
        };
    },
    methods: {
        open(params) {
            this.params = params;
            this.$refs[this.modalRef].show();
        },
        close() {
            this.isLoading = false;
            this.$refs[this.modalRef].hide();
        },
        async save() {
            this.isLoading = true;
            this.$emit("proceed");
            this.close();
        }
    }
};
</script>
